import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import backdropGif from '../assets/gamesbackdrop.gif';
import rgmBanner from '../assets/rgmbanner.svg';
import './FengCheng.css';

const FENGCHENG_URL = 'https://rgm.games/game/939';

const FengCheng = () => {
  const [backdropLoaded, setBackdropLoaded] = useState(false);
  const [showNotices, setShowNotices] = useState(false);
  const imgRef = useRef(null);

  useEffect(() => {
    const img = new Image();
    img.onload = () => setBackdropLoaded(true);
    img.src = backdropGif;
  }, []);

  return (
    <div className="fc-page">
      <Navbar />

      {/* Backdrop GIF */}
      <div className={`fc-backdrop ${backdropLoaded ? 'fc-backdrop--loaded' : ''}`}>
        <img
          src={backdropGif}
          alt=""
          className="fc-backdrop-img"
          ref={imgRef}
        />
        <div className="fc-backdrop-overlay" />
      </div>

      <div className="fc-container">
        <main className="fc-main">
          <div className="fc-layout">

            {/* Left Panel */}
            <aside className="fc-left fc-fade-in">
              <img src={rgmBanner} alt="怀旧游戏博物馆" className="fc-banner" />

              <p className="fc-about-text">
                关于怀旧游戏博物馆：我们致力于将经典游戏搬上浏览器，现已有近千老游戏在手机和电脑的网页上能无广告免费游玩。从4399，到魂斗罗，到植物大战僵尸，到宝可梦。
              </p>

              <div className="fc-nav-links">
                <Link to="/feed" className="fc-nav-link">
                  <span className="fc-nav-icon">
                    <svg viewBox="0 0 1024 1024" width="22" height="22" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" d="M85.312 85.312v853.376h853.376V85.312H85.312zM0 0h1024v1024H0V0z m469.312 682.688v-128h85.376v128h138.304L512 863.68l-180.992-180.992h138.304z m85.376-341.376v128H469.312v-128H331.008L512 160.32l180.992 180.992H554.688z" fill="rgba(228,203,134,0.55)" />
                    </svg>
                  </span>
                  <span className="fc-nav-text">
                    <span className="fc-nav-label">进入游戏流</span>
                    <span className="fc-nav-tagline">进入游戏推荐</span>
                  </span>
                  <span className="fc-nav-arrow">→</span>
                </Link>
                <Link to="/games" className="fc-nav-link">
                  <span className="fc-nav-icon">
                    <svg viewBox="0 0 1047 1024" width="22" height="22" xmlns="http://www.w3.org/2000/svg">
                      <path d="M550.245209 0h-157.219721c-28.814884 0-52.390698 23.575814-52.390697 52.390698v890.88c0 28.814884 23.575814 52.390698 52.390697 52.390697h157.219721c28.814884 0 52.390698-23.575814 52.390698-52.390697V52.390698c0-28.814884-23.575814-52.390698-52.390698-52.390698z" fill="rgba(228,203,134,0.55)" />
                      <path d="M209.610419 209.610419H52.414512c-28.814884 0-52.390698 23.575814-52.390698 52.390697V943.270698c0 28.814884 23.575814 52.390698 52.390698 52.390697h157.195907c28.814884 0 52.390698-23.575814 52.390697-52.390697V262.02493c0-28.814884-23.575814-52.390698-52.390697-52.390697z" fill="rgba(228,203,134,0.55)" />
                      <path d="M1045.456372 919.694884L927.553488 248.927256c-5.23907-28.814884-31.434419-47.151628-60.273116-41.912558l-154.600186 26.195349c-28.814884 5.23907-47.151628 31.434419-41.912558 60.249302l117.902884 670.767628c5.23907 28.814884 31.434419 47.151628 60.249302 41.912558l154.600186-26.195349c28.814884-5.23907 47.151628-31.434419 41.912558-60.249302z" fill="rgba(228,203,134,0.55)" />
                    </svg>
                  </span>
                  <span className="fc-nav-text">
                    <span className="fc-nav-label">进入游戏库</span>
                    <span className="fc-nav-tagline">查看全部游戏</span>
                  </span>
                  <span className="fc-nav-arrow">→</span>
                </Link>
              </div>
            </aside>

            {/* Center — Main CTA */}
            <div className="fc-center fc-fade-in fc-fade-in--delay-1">
              <div className="fc-title-block">
                <h1 className="fc-title">枫城 2026</h1>
                <p className="fc-subtitle">预览版</p>
              </div>

              <button
                className="fc-launch-btn"
                onClick={() => setShowNotices(true)}
              >
                <span className="fc-launch-icon">▶</span>
                启动
              </button>

            </div>

            {/* Right Panel */}
            <aside className="fc-right fc-fade-in fc-fade-in--delay-2">
              <h2 className="fc-steps-title">启动步骤</h2>
              <ol className="fc-steps">
                <li className="fc-step">
                  <span className="fc-step-num">1</span>
                  <span className="fc-step-text">点击链接进入游戏界面</span>
                </li>
                <li className="fc-step">
                  <span className="fc-step-num">2</span>
                  <span className="fc-step-text">耐心等待枫城的下载和导入</span>
                </li>
                <li className="fc-step">
                  <span className="fc-step-num">3</span>
                  <span className="fc-step-text">
                    当显示 <span className="fc-step-highlight">"press any key to enable sound"</span>，点击界面以关闭提示
                  </span>
                </li>
                <li className="fc-step">
                  <span className="fc-step-num">4</span>
                  <span className="fc-step-text">
                    点击 <span className="fc-step-highlight">"Done"</span> 进入主菜单
                  </span>
                </li>
                <li className="fc-step">
                  <span className="fc-step-num">5</span>
                  <span className="fc-step-text">
                    点击 <span className="fc-step-highlight">"Singleplayer"</span>
                  </span>
                </li>
                <li className="fc-step">
                  <span className="fc-step-num">6</span>
                  <span className="fc-step-text">
                    加载 <span className="fc-step-highlight">"枫城2026 RGM在线特供版"</span>
                  </span>
                </li>
              </ol>

              <div className="fc-notes">
                <p className="fc-note-item">注：苹果手机暂不支持</p>
                <p className="fc-note-item">如果误删地图，可以点击“重新安装枫城”进行覆盖</p>
              </div>
            </aside>

          </div>
        </main>
      </div>
      {showNotices && (
        <div className="fc-modal-overlay" onClick={() => setShowNotices(false)}>
          <div className="fc-modal" onClick={e => e.stopPropagation()}>
            <p className="fc-modal-label">启动前须知</p>
            <ul className="fc-modal-notices">
              <li className="fc-modal-notice">
                <span className="fc-modal-notice-icon">⚠</span>
                本版本暂不支持苹果手机和平板，建议用电脑或安卓使用
              </li>
              <li className="fc-modal-notice">
                <span className="fc-modal-notice-icon">⚠</span>
                为了避免滥用，部分方块进行了混淆
              </li>
              <li className="fc-modal-notice">
                <span className="fc-modal-notice-icon">⚠</span>
                本预览版在线运行，一定程度的卡顿无法避免
              </li>
            </ul>
            <a
              href={FENGCHENG_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="fc-modal-confirm"
              onClick={() => setShowNotices(false)}
            >
              知道了，继续
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default FengCheng;
